import { registerPlugin } from '@capacitor/core';

export interface GoogleAuthPlugin {
  initialize(options?: {
    clientId?: string;
    serverClientId?: string;
    scopes?: string[];
    grantOfflineAccess?: boolean;
  }): Promise<void>;

  signIn(options?: {
    scopes?: string[];
  }): Promise<{
    authentication: {
      accessToken: string;
      idToken: string | null;
      refreshToken: string;
    };
    serverAuthCode: string | null;
    email: string | null;
    familyName: string | null;
    givenName: string | null;
    id: string | null;
    name: string | null;
    imageUrl?: string;
  }>;

  refresh(): Promise<{
    accessToken: string;
    idToken: string | null;
    refreshToken: string;
  }>;

  signOut(): Promise<void>;
}

export const GoogleAuth = registerPlugin<GoogleAuthPlugin>('GoogleAuth');
